var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"text-area-dropdown-options"},[_c('v-textarea',{attrs:{"outlined":"","no-resize":"","placeholder":_vm.placeholder,"rules":_vm.rules},on:{"change":_vm.valueChanged},model:{value:(_vm.optionsItems),callback:function ($$v) {_vm.optionsItems=$$v},expression:"optionsItems"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }